import _slicedToArray from "/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable jsdoc/check-param-names */
import { curryN, pipe, rest, identity, isNumber, sortBy, get } from 'lodash/fp';
/**
 * Makes sure that given value is inside specified range.
 * If min or max value is not specified (argument is null),
 * function will treat that side of range as it would be Infinity.
 *
 * @param {?number} minValue - Minimal accepted value
 * @param {?number} maxValue - Maximal accepted value
 * @param {number} value - Value for verification
 *
 * @returns {number} result - unmodified value if inside range
 * or min/max value if outside of range
 *
 * @example
 * ensureInRange(5, 15, 10) // returns 10
 * ensureInRange(5, 15, 20) // returns 15
 * ensureInRange(5, 15, 0) // returns 5
 * ensureInRange(5, null, 10) // returns 10
 * ensureInRange(5, null, 0) // returns 5
 */

export var ensureInRange = curryN(3, pipe([rest(identity), function (_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      minValue = _ref2[0],
      maxValue = _ref2[1],
      value = _ref2[2];

  return [isNumber(minValue) ? minValue : -Infinity, isNumber(maxValue) ? maxValue : Infinity, value];
}, sortBy(identity), get(1)]));
export default ensureInRange;